<template>
    <div>
        <b-row>
            <b-col cols=4>
                <h5>Select Location</h5>
                <webix-ui :config="location_config" v-model="locations"></webix-ui>
            </b-col>
            <b-col cols=8>
                <h5>Add Suppliers to Location</h5>
                <webix-ui :config="supplier_config" v-model="suppliers_for_location"></webix-ui>
                <b-alert class="mt-2" :show="selected_location === null">
                    <strong>
                        No Location Selected
                    </strong>
                </b-alert>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from 'lodash'
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
export default {
    data:() => ({
        selected_location:null,
        clickedAction: false,

        //* CONFIGS */
        location_config:{
            id: 'locationsLinkingTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'name', header:'Location Name', fillspace: true},
                { id: 'sqm', header:'Size', fillspace: 0.4},
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    var el = this.$scope.$parent;
                    setTimeout(()=>{
                        if(el.clickedAction == false){
                            let record = this.getItem(id);
                            el.selected_location = record;
                        }
                    }, 50)
                }
            },
            onClick:{
                
            }
        },
        supplier_config:{
            id: 'suppliersLinkingTable',
            view: 'datatable',
            css: "datatableUsers, webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'actions', header:'', fillspace: 0.15,  template: function(object){
                    let element = '';
                    if(object.icon){
                        element = `<i title="Linked Supplier" class="webix_icon fas fa-check"></i>`;
                    }
                    else{
                        element = `<i title="Unlinked Supplier" class="webix_icon fas fa-times"></i>`;
                    }
                    return element;
                }},
                { id: 'company_name', header:'Company Name', fillspace: true},
                { id: 'contact_person', header:'Contact Person', fillspace: 0.4},
                { id: 'activity_description', header:'Supplier Activity Description', fillspace: 1.2},
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    
                    var el = this.$scope.$parent;
                    let item = this.getItem(id);
                    console.log(item);
                    if(item.icon){
                        console.log('unlink');
                        
                    }
                    else{
                        console.log('link supplier to level');
                        el.linkSupplier(id.row);
                    }
                    el.$nextTick(()=>{
                        this.clearSelection();
                    });
                }
            },
        },
    }),
    computed:{
        ...facilityAdminState,
        locations(){
            let data = [];
            if(this.client_locations != null){
                data = this.client_locations
            }
            return data;
        },
        suppliers(){
            let data = [];
            if(this.client_suppliers != null){
                data = this.client_suppliers
            }
            return data;
        },
        suppliers_for_location(){
            if(this.selected_location != null){
                //* add css and action bool to each supplier that exists for the current location
                let data = [];
                let sups = _.cloneDeep(this.client_suppliers);
                sups.forEach(item => {
                    let index = _.findIndex(this.locations.suppliers, { id: item.id });
                    if(index != -1){
                        if(item.id == 1){
                            item['$css'] = 'is_added';
                            item['icon'] = true;
                        }
                    }
                    data.push(item);
                })
                return data;
            }
            else{
                return [];
            }
        }
    },
    watch:{
        selected_location(){
            /* eslint-disable-next-line */
            let table = $$('suppliersLinkingTable');
            table.refresh();
        }
    },
    methods:{
        ...facilityAdminMethods,
        linkSupplier(id){
            let params = {
                location_id: this.selected_location.id,
                supplier_id: id,
            }
            this.linkLocationSupplier(params)
            .then(()=>{
                this.loadClientLocations();
            })
        },

        testStuff(){
            let params = {
                location_id: 1,
                supplier_id: 1,
            }
            this.linkLocationSupplier(params);
        }
    },
    mounted(){},
}
</script>

<style>
    .is_added{
        background-color: rgba(30, 255, 98, 0.295);
    }
</style>